module.exports = __webpack_public_path__ + "img/down.b4135064.svg";